import script from "./changeRegionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./changeRegionForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__